import { EFormBlockBackground, getFormBlockTint } from '@onesource/schemas';

/**
 * Colours of the teacher's feedback, on the page and in the PDF. The workbook's
 * calm teal, so feedback never reads like the red "submit again" notice beside it.
 */
export const FEEDBACK_TINT = getFormBlockTint(EFormBlockBackground.IN_YOUR_PRACTICE);
